import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";
import { Dialog, DialogContent, Paper, Typography, Button, CircularProgress } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");
  const [failed, setFailed] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    setQrCode(""); setFailed(false);
    if (!open || !whatsAppId) return;
    let active = true, pending = false, notified = false;
    const apply = session => {
      if (!active || String(session?.id) !== String(whatsAppId)) return;
      setQrCode(session.qrcode || "");
      if (session.status === "CONNECTED") onClose();
    };
    const fetchSession = async () => {
      if (pending) return;
      pending = true;
      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        if (active) { setFailed(false); apply(data); }
      } catch (err) {
        if (active) { setFailed(true); if (!notified) { toastError(err); notified = true; } }
      } finally { pending = false; }
    };
    const socket = openSocket();
    socket.on("whatsappSession", data => { if (data.action === "update") apply(data.session); });
    socket.on("connect", fetchSession);
    fetchSession();
    const interval = setInterval(fetchSession, 4000);
    return () => { active = false; clearInterval(interval); socket.disconnect(); };
  }, [open, whatsAppId, onClose, reload]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" scroll="paper">
      <DialogContent>
        <Paper elevation={0} style={{ textAlign: "center", padding: 8 }}>
          <Typography color="primary" gutterBottom>{i18n.t("qrCode.message")}</Typography>
          {qrCode ? <QRCode value={qrCode} size={256} style={{maxWidth:"100%", height:"auto"}} /> : <>
            <CircularProgress size={28} />
            <Typography role="status">{failed ? "Não foi possível consultar a conexão." : "Aguardando o WhatsApp gerar o QR Code…"}</Typography>
            <Button onClick={() => setReload(value => value + 1)}>Consultar novamente</Button>
          </>}
        </Paper>
      </DialogContent>
    </Dialog>
  );
};
export default React.memo(QrcodeModal);
